/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { DatePicker } from "@repo/ui";

export default function FormHookDatePicker({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  errors,
  control,
  datePickerProps,
  onDateChange,
}) {
  return (
    <FormControl isRequired={Boolean(isRequired)}>
      <FormLabel>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => {
          return (
            <DatePicker
              placeholder="Select Date"
              selectedDate={field.value || null}
              disabled={disabled}
              className={errors && errors[name] ? "error-field" : ""}
              onSelectDate={(e) => {
                if (onDateChange) {
                  onDateChange(e);
                }
                field.onChange(e);
              }}
            />
          );
        }}
      />
      {info ? (
        <p className="text-sm text-gray-500 mt-1 italic">{info || ""}</p>
      ) : (
        <></>
      )}
      {errors ? (
        errors[name] ? (
          <p className="text-sm text-red-500 mt-1">
            {errors[name].message || "Please Select Date!"}
          </p>
        ) : (
          <></>
        )
      ) : (
        <></>
      )}
    </FormControl>
  );
}
